//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getBuildsV2(ontologyProject: string, workspaceId: string , cancelToken?: CancelToken | undefined): Promise<Build[]> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/builds";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildsV2(_response);
        });
    }

    protected processGetBuildsV2(response: AxiosResponse): Promise<Build[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Build.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Build[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Build[]>(null as any);
    }

    /**
     * @return Created
     */
    startBuildV2(ontologyProject: string, workspaceId: string, body: BuildRequest , cancelToken?: CancelToken | undefined): Promise<Build> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/builds";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartBuildV2(_response);
        });
    }

    protected processStartBuildV2(response: AxiosResponse): Promise<Build> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = Build.fromJS(resultData201);
            return Promise.resolve<Build>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Build>(null as any);
    }

    /**
     * @return Success
     */
    getBuildsLogV2(ontologyProject: string, workspaceId: string, buildId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/builds/{buildId}/log";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (buildId === undefined || buildId === null)
            throw new Error("The parameter 'buildId' must be defined.");
        url_ = url_.replace("{buildId}", encodeURIComponent("" + buildId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/zip"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildsLogV2(_response);
        });
    }

    protected processGetBuildsLogV2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBuildsDropV2(ontologyProject: string, workspaceId: string, buildId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/builds/{buildId}/drop";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (buildId === undefined || buildId === null)
            throw new Error("The parameter 'buildId' must be defined.");
        url_ = url_.replace("{buildId}", encodeURIComponent("" + buildId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/zip"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildsDropV2(_response);
        });
    }

    protected processGetBuildsDropV2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getOntologies(  cancelToken?: CancelToken | undefined): Promise<OntologyProject[]> {
        let url_ = this.baseUrl + "/ontologies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOntologies(_response);
        });
    }

    protected processGetOntologies(response: AxiosResponse): Promise<OntologyProject[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OntologyProject.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OntologyProject[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OntologyProject[]>(null as any);
    }

    /**
     * @return Success
     */
    getSettings(  cancelToken?: CancelToken | undefined): Promise<SystemSetting> {
        let url_ = this.baseUrl + "/settings/system";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<SystemSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemSetting.fromJS(resultData200);
            return Promise.resolve<SystemSetting>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemSetting>(null as any);
    }

    /**
     * @return Success
     */
    getSettingsV2(ontologyProject: string , cancelToken?: CancelToken | undefined): Promise<SystemSetting> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/settings/system";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingsV2(_response);
        });
    }

    protected processGetSettingsV2(response: AxiosResponse): Promise<SystemSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemSetting.fromJS(resultData200);
            return Promise.resolve<SystemSetting>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemSetting>(null as any);
    }

    /**
     * @return Success
     */
    getSourceTables(workspaceId: string , cancelToken?: CancelToken | undefined): Promise<SourceTable[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/sourcetables";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourceTables(_response);
        });
    }

    protected processGetSourceTables(response: AxiosResponse): Promise<SourceTable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceTable.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SourceTable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTable[]>(null as any);
    }

    /**
     * @return Success
     */
    getExternalTables(  cancelToken?: CancelToken | undefined): Promise<SourceTable[]> {
        let url_ = this.baseUrl + "/externaltables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalTables(_response);
        });
    }

    protected processGetExternalTables(response: AxiosResponse): Promise<SourceTable[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceTable.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SourceTable[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTable[]>(null as any);
    }

    /**
     * @return Success
     */
    getExternalTableMetaData(workspaceId: string, sourceTableId: string , cancelToken?: CancelToken | undefined): Promise<ExternalTableMetaData> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/externaltables/{sourceTableId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalTableMetaData(_response);
        });
    }

    protected processGetExternalTableMetaData(response: AxiosResponse): Promise<ExternalTableMetaData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalTableMetaData.fromJS(resultData200);
            return Promise.resolve<ExternalTableMetaData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalTableMetaData>(null as any);
    }

    /**
     * @return Accepted
     */
    loadExternalTables(workspaceId: string, sourceTableId: string, namespacePrefix: string, approvalStatus: string, dataQuery: string, changeNote: string, labelColumn: string, body: string[] , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/externaltables/{sourceTableId}/load?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        if (namespacePrefix === undefined || namespacePrefix === null)
            throw new Error("The parameter 'namespacePrefix' must be defined and cannot be null.");
        else
            url_ += "namespacePrefix=" + encodeURIComponent("" + namespacePrefix) + "&";
        if (approvalStatus === undefined || approvalStatus === null)
            throw new Error("The parameter 'approvalStatus' must be defined and cannot be null.");
        else
            url_ += "approvalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        if (dataQuery === undefined || dataQuery === null)
            throw new Error("The parameter 'dataQuery' must be defined and cannot be null.");
        else
            url_ += "dataQuery=" + encodeURIComponent("" + dataQuery) + "&";
        if (changeNote === undefined || changeNote === null)
            throw new Error("The parameter 'changeNote' must be defined and cannot be null.");
        else
            url_ += "changeNote=" + encodeURIComponent("" + changeNote) + "&";
        if (labelColumn === undefined || labelColumn === null)
            throw new Error("The parameter 'labelColumn' must be defined and cannot be null.");
        else
            url_ += "labelColumn=" + encodeURIComponent("" + labelColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadExternalTables(_response);
        });
    }

    protected processLoadExternalTables(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Accepted
     */
    loadExternalTablesV2(body: LoadExternalTableRequest , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/workspaces/{workspaceId}/externaltables/{sourceTableId}/load";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadExternalTablesV2(_response);
        });
    }

    protected processLoadExternalTablesV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Accepted
     */
    refreshExternalTables(workspaceId: string, sourceTableId: string, changeNote: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/externaltables/{sourceTableId}/refresh?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        if (changeNote === undefined || changeNote === null)
            throw new Error("The parameter 'changeNote' must be defined and cannot be null.");
        else
            url_ += "changeNote=" + encodeURIComponent("" + changeNote) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshExternalTables(_response);
        });
    }

    protected processRefreshExternalTables(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getExternalTableColumns(sourceTableId: string , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/externaltables/{sourceTableId}/columns";
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalTableColumns(_response);
        });
    }

    protected processGetExternalTableColumns(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getSourceTableColumns(workspaceId: string, sourceTableId: string , cancelToken?: CancelToken | undefined): Promise<SourceTableColumn[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/sourcetables/{sourceTableId}/columns";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourceTableColumns(_response);
        });
    }

    protected processGetSourceTableColumns(response: AxiosResponse): Promise<SourceTableColumn[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceTableColumn.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SourceTableColumn[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTableColumn[]>(null as any);
    }

    /**
     * @return Success
     */
    getSourceTableRows(workspaceId: string, sourceTableId: string , cancelToken?: CancelToken | undefined): Promise<SourceTableRow[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/sourcetables/{sourceTableId}/rows";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourceTableRows(_response);
        });
    }

    protected processGetSourceTableRows(response: AxiosResponse): Promise<SourceTableRow[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceTableRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SourceTableRow[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTableRow[]>(null as any);
    }

    /**
     * @return Created
     */
    createSourceTableRow(workspaceId: string, sourceTableId: string, index: number, body: SourceTableRow , cancelToken?: CancelToken | undefined): Promise<SourceTableRow> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/sourcetables/{sourceTableId}/rows/{index}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSourceTableRow(_response);
        });
    }

    protected processCreateSourceTableRow(response: AxiosResponse): Promise<SourceTableRow> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SourceTableRow.fromJS(resultData201);
            return Promise.resolve<SourceTableRow>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTableRow>(null as any);
    }

    /**
     * @return Created
     */
    modifySourceTableRow(oid: string, workspaceId: string, sourceTableId: string, rowId: string, body: SourceTableRow , cancelToken?: CancelToken | undefined): Promise<SourceTableRow> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}/sourcetables/{sourceTableId}/rows/{rowId}";
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        if (rowId === undefined || rowId === null)
            throw new Error("The parameter 'rowId' must be defined.");
        url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifySourceTableRow(_response);
        });
    }

    protected processModifySourceTableRow(response: AxiosResponse): Promise<SourceTableRow> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SourceTableRow.fromJS(resultData201);
            return Promise.resolve<SourceTableRow>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTableRow>(null as any);
    }

    /**
     * @return Success
     */
    deleteSourceTableRow(oid: string, workspaceId: string, sourceTableId: string, rowId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}/sourcetables/{sourceTableId}/rows/{rowId}";
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        if (rowId === undefined || rowId === null)
            throw new Error("The parameter 'rowId' must be defined.");
        url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSourceTableRow(_response);
        });
    }

    protected processDeleteSourceTableRow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Created
     */
    modifySourceTableRowV2(ontologyProject: string, workspaceId: string, sourceTableId: string, rowId: string, body: SourceTableRow , cancelToken?: CancelToken | undefined): Promise<SourceTableRow> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/sourcetables/{sourceTableId}/rows/{rowId}";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        if (rowId === undefined || rowId === null)
            throw new Error("The parameter 'rowId' must be defined.");
        url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifySourceTableRowV2(_response);
        });
    }

    protected processModifySourceTableRowV2(response: AxiosResponse): Promise<SourceTableRow> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SourceTableRow.fromJS(resultData201);
            return Promise.resolve<SourceTableRow>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTableRow>(null as any);
    }

    /**
     * @return Success
     */
    deleteSourceTableRowV2(ontologyProject: string, workspaceId: string, sourceTableId: string, rowId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/sourcetables/{sourceTableId}/rows/{rowId}";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        if (rowId === undefined || rowId === null)
            throw new Error("The parameter 'rowId' must be defined.");
        url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSourceTableRowV2(_response);
        });
    }

    protected processDeleteSourceTableRowV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Created
     */
    modifySourceTableRowId(ontologyProject: string, workspaceId: string, sourceTableId: string, rowId: string, body: UpdateIriRequest , cancelToken?: CancelToken | undefined): Promise<SourceTableRow> {
        let url_ = this.baseUrl + "/ontologies/{ontologyProject}/workspaces/{workspaceId}/sourcetables/{sourceTableId}/rows/{rowId}";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        if (rowId === undefined || rowId === null)
            throw new Error("The parameter 'rowId' must be defined.");
        url_ = url_.replace("{rowId}", encodeURIComponent("" + rowId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifySourceTableRowId(_response);
        });
    }

    protected processModifySourceTableRowId(response: AxiosResponse): Promise<SourceTableRow> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SourceTableRow.fromJS(resultData201);
            return Promise.resolve<SourceTableRow>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTableRow>(null as any);
    }

    /**
     * @return Success
     */
    deleteSourceTable(oid: string, workspaceId: string, sourceTableId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}/sourcetables/{sourceTableId}";
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSourceTable(_response);
        });
    }

    protected processDeleteSourceTable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteSourceTableV2(ontologyProject: string, workspaceId: string, sourceTableId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/sourcetables/{sourceTableId}";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSourceTableV2(_response);
        });
    }

    protected processDeleteSourceTableV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    searchInSourceTables(workspaceId: string, searchString: string , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/search/{searchString}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInSourceTables(_response);
        });
    }

    protected processSearchInSourceTables(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Created
     */
    moveSourceTableRow(oid: string, workspaceId: string, sourceTableIdSource: string, sourceTableIdDestination: string, body: SourceTableRow , cancelToken?: CancelToken | undefined): Promise<SourceTableRow> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}/sourcetables/{sourceTableIdSource}/{sourceTableIdDestination}";
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableIdSource === undefined || sourceTableIdSource === null)
            throw new Error("The parameter 'sourceTableIdSource' must be defined.");
        url_ = url_.replace("{sourceTableIdSource}", encodeURIComponent("" + sourceTableIdSource));
        if (sourceTableIdDestination === undefined || sourceTableIdDestination === null)
            throw new Error("The parameter 'sourceTableIdDestination' must be defined.");
        url_ = url_.replace("{sourceTableIdDestination}", encodeURIComponent("" + sourceTableIdDestination));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveSourceTableRow(_response);
        });
    }

    protected processMoveSourceTableRow(response: AxiosResponse): Promise<SourceTableRow> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SourceTableRow.fromJS(resultData201);
            return Promise.resolve<SourceTableRow>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTableRow>(null as any);
    }

    /**
     * @return Created
     */
    moveSourceTableRowV2(ontologyProject: string, workspaceId: string, sourceTableIdSource: string, sourceTableIdDestination: string, body: SourceTableRow , cancelToken?: CancelToken | undefined): Promise<SourceTableRow> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/sourcetables/{sourceTableIdSource}/{sourceTableIdDestination}";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableIdSource === undefined || sourceTableIdSource === null)
            throw new Error("The parameter 'sourceTableIdSource' must be defined.");
        url_ = url_.replace("{sourceTableIdSource}", encodeURIComponent("" + sourceTableIdSource));
        if (sourceTableIdDestination === undefined || sourceTableIdDestination === null)
            throw new Error("The parameter 'sourceTableIdDestination' must be defined.");
        url_ = url_.replace("{sourceTableIdDestination}", encodeURIComponent("" + sourceTableIdDestination));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveSourceTableRowV2(_response);
        });
    }

    protected processMoveSourceTableRowV2(response: AxiosResponse): Promise<SourceTableRow> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SourceTableRow.fromJS(resultData201);
            return Promise.resolve<SourceTableRow>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceTableRow>(null as any);
    }

    /**
     * @return Accepted
     */
    syncSourceTable(ontologyProject: string, workspaceId: string, sourceTableId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ontologies/{ontologyProject}/workspaces/{workspaceId}/sourcetables/{sourceTableId}/synchronize";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (sourceTableId === undefined || sourceTableId === null)
            throw new Error("The parameter 'sourceTableId' must be defined.");
        url_ = url_.replace("{sourceTableId}", encodeURIComponent("" + sourceTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncSourceTable(_response);
        });
    }

    protected processSyncSourceTable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getSnapshots(workspaceId: string , cancelToken?: CancelToken | undefined): Promise<Snapshot[]> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/snapshots";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSnapshots(_response);
        });
    }

    protected processGetSnapshots(response: AxiosResponse): Promise<Snapshot[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Snapshot.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Snapshot[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Snapshot[]>(null as any);
    }

    /**
     * @return Created
     */
    createSnapshot(workspaceId: string, oid: string, body: SnapshotRequest , cancelToken?: CancelToken | undefined): Promise<Snapshot> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}/snapshots";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSnapshot(_response);
        });
    }

    protected processCreateSnapshot(response: AxiosResponse): Promise<Snapshot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = Snapshot.fromJS(resultData201);
            return Promise.resolve<Snapshot>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Snapshot>(null as any);
    }

    /**
     * @return Created
     */
    createSnapshotV2(ontologyProject: string, workspaceId: string, body: SnapshotRequest , cancelToken?: CancelToken | undefined): Promise<Snapshot> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/snapshots";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSnapshotV2(_response);
        });
    }

    protected processCreateSnapshotV2(response: AxiosResponse): Promise<Snapshot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = Snapshot.fromJS(resultData201);
            return Promise.resolve<Snapshot>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Snapshot>(null as any);
    }

    /**
     * @return Success
     */
    deleteSnapshot(workspaceId: string, snapshotId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/snapshots/{snapshotId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (snapshotId === undefined || snapshotId === null)
            throw new Error("The parameter 'snapshotId' must be defined.");
        url_ = url_.replace("{snapshotId}", encodeURIComponent("" + snapshotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSnapshot(_response);
        });
    }

    protected processDeleteSnapshot(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Accepted
     */
    loadSnapshot(workspaceId: string, oid: string, snapshotId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}/snapshots/{snapshotId}/load";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        if (snapshotId === undefined || snapshotId === null)
            throw new Error("The parameter 'snapshotId' must be defined.");
        url_ = url_.replace("{snapshotId}", encodeURIComponent("" + snapshotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadSnapshot(_response);
        });
    }

    protected processLoadSnapshot(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Accepted
     */
    loadSnapshotV2(ontologyProject: string, workspaceId: string, snapshotId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/snapshots/{snapshotId}/load";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (snapshotId === undefined || snapshotId === null)
            throw new Error("The parameter 'snapshotId' must be defined.");
        url_ = url_.replace("{snapshotId}", encodeURIComponent("" + snapshotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadSnapshotV2(_response);
        });
    }

    protected processLoadSnapshotV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getWorkspaces(  cancelToken?: CancelToken | undefined): Promise<Workspace[]> {
        let url_ = this.baseUrl + "/workspaces";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkspaces(_response);
        });
    }

    protected processGetWorkspaces(response: AxiosResponse): Promise<Workspace[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Workspace.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Workspace[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Workspace[]>(null as any);
    }

    /**
     * @return Created
     */
    createWorkspace(body: WorkspaceRequest , cancelToken?: CancelToken | undefined): Promise<Workspace> {
        let url_ = this.baseUrl + "/workspaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWorkspace(_response);
        });
    }

    protected processCreateWorkspace(response: AxiosResponse): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = Workspace.fromJS(resultData201);
            return Promise.resolve<Workspace>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Workspace>(null as any);
    }

    /**
     * @return Success
     */
    getWorkspacesV2(ontologyProject: string , cancelToken?: CancelToken | undefined): Promise<Workspace[]> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkspacesV2(_response);
        });
    }

    protected processGetWorkspacesV2(response: AxiosResponse): Promise<Workspace[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Workspace.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Workspace[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Workspace[]>(null as any);
    }

    /**
     * @return Created
     */
    createWorkspaceV2(ontologyProject: string, body: WorkspaceRequest , cancelToken?: CancelToken | undefined): Promise<Workspace> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWorkspaceV2(_response);
        });
    }

    protected processCreateWorkspaceV2(response: AxiosResponse): Promise<Workspace> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = Workspace.fromJS(resultData201);
            return Promise.resolve<Workspace>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Workspace>(null as any);
    }

    /**
     * @return Success
     */
    editWorkspace(workspaceId: string, oid: string, body: WorkspaceRequest , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditWorkspace(_response);
        });
    }

    protected processEditWorkspace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteWorkspace(workspaceId: string, oid: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWorkspace(_response);
        });
    }

    protected processDeleteWorkspace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    editWorkspaceV2(ontologyProject: string, workspaceId: string, body: WorkspaceRequest , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditWorkspaceV2(_response);
        });
    }

    protected processEditWorkspaceV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteWorkspaceV2(workspaceId: string, ontologyProject: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWorkspaceV2(_response);
        });
    }

    protected processDeleteWorkspaceV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Accepted
     */
    publishWorkspace(workspaceId: string, oid: string, body: WorkspacePublishRequest , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}/publish";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishWorkspace(_response);
        });
    }

    protected processPublishWorkspace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Accepted
     */
    publishWorkspaceV2(ontologyProject: string, workspaceId: string, body: WorkspacePublishRequest , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/publish";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishWorkspaceV2(_response);
        });
    }

    protected processPublishWorkspaceV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    unlockWorkspace(workspaceId: string, oid: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/workspaces/{oid}/{workspaceId}/unlock";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlockWorkspace(_response);
        });
    }

    protected processUnlockWorkspace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    unlockWorkspaceV2(ontologyProject: string, workspaceId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v2/ontologies/{ontologyProject}/workspaces/{workspaceId}/unlock";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlockWorkspaceV2(_response);
        });
    }

    protected processUnlockWorkspaceV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getIriEntity(workspaceId: string, iri: string , cancelToken?: CancelToken | undefined): Promise<IriLabelRelation> {
        let url_ = this.baseUrl + "/workspaces/{workspaceId}/iri/{iri}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (iri === undefined || iri === null)
            throw new Error("The parameter 'iri' must be defined.");
        url_ = url_.replace("{iri}", encodeURIComponent("" + iri));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIriEntity(_response);
        });
    }

    protected processGetIriEntity(response: AxiosResponse): Promise<IriLabelRelation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IriLabelRelation.fromJS(resultData200);
            return Promise.resolve<IriLabelRelation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IriLabelRelation>(null as any);
    }

    /**
     * @return Success
     */
    getMetadata(ontologyProject: string, workspaceId: string , cancelToken?: CancelToken | undefined): Promise<ProjectMetadata> {
        let url_ = this.baseUrl + "/ontologies/{ontologyProject}/workspaces/{workspaceId}/metadata";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMetadata(_response);
        });
    }

    protected processGetMetadata(response: AxiosResponse): Promise<ProjectMetadata> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectMetadata.fromJS(resultData200);
            return Promise.resolve<ProjectMetadata>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectMetadata>(null as any);
    }

    /**
     * @return Success
     */
    modifyMetadata(ontologyProject: string, workspaceId: string, body: ProjectMetadata , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ontologies/{ontologyProject}/workspaces/{workspaceId}/metadata";
        if (ontologyProject === undefined || ontologyProject === null)
            throw new Error("The parameter 'ontologyProject' must be defined.");
        url_ = url_.replace("{ontologyProject}", encodeURIComponent("" + ontologyProject));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyMetadata(_response);
        });
    }

    protected processModifyMetadata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export enum ApprovalStatus {
    Define = "Define",
    Implement = "Implement",
    Use = "Use",
    Validate = "Validate",
    Deprecate = "Deprecate",
}

export class Build implements IBuild {
    id!: string;
    description!: string;
    state!: BuildState;
    createdTimestamp!: Date;
    owner!: string;
    ownerId!: string;
    modifiedTimestamp?: Date | undefined;
    downloadLink?: string | undefined;
    artifactLink?: string | undefined;

    constructor(data?: IBuild) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.state = _data["state"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : <any>undefined;
            this.owner = _data["owner"];
            this.ownerId = _data["ownerId"];
            this.modifiedTimestamp = _data["modifiedTimestamp"] ? new Date(_data["modifiedTimestamp"].toString()) : <any>undefined;
            this.downloadLink = _data["downloadLink"];
            this.artifactLink = _data["artifactLink"];
        }
    }

    static fromJS(data: any): Build {
        data = typeof data === 'object' ? data : {};
        let result = new Build();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["state"] = this.state;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : <any>undefined;
        data["owner"] = this.owner;
        data["ownerId"] = this.ownerId;
        data["modifiedTimestamp"] = this.modifiedTimestamp ? this.modifiedTimestamp.toISOString() : <any>undefined;
        data["downloadLink"] = this.downloadLink;
        data["artifactLink"] = this.artifactLink;
        return data;
    }
}

export interface IBuild {
    id: string;
    description: string;
    state: BuildState;
    createdTimestamp: Date;
    owner: string;
    ownerId: string;
    modifiedTimestamp?: Date | undefined;
    downloadLink?: string | undefined;
    artifactLink?: string | undefined;
}

export class BuildRequest implements IBuildRequest {
    description!: string;
    approvalStatusFilters?: ApprovalStatus[] | undefined;
    modelStatusFilters?: ModelStatus[] | undefined;

    constructor(data?: IBuildRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            if (Array.isArray(_data["approvalStatusFilters"])) {
                this.approvalStatusFilters = [] as any;
                for (let item of _data["approvalStatusFilters"])
                    this.approvalStatusFilters!.push(item);
            }
            if (Array.isArray(_data["modelStatusFilters"])) {
                this.modelStatusFilters = [] as any;
                for (let item of _data["modelStatusFilters"])
                    this.modelStatusFilters!.push(item);
            }
        }
    }

    static fromJS(data: any): BuildRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BuildRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (Array.isArray(this.approvalStatusFilters)) {
            data["approvalStatusFilters"] = [];
            for (let item of this.approvalStatusFilters)
                data["approvalStatusFilters"].push(item);
        }
        if (Array.isArray(this.modelStatusFilters)) {
            data["modelStatusFilters"] = [];
            for (let item of this.modelStatusFilters)
                data["modelStatusFilters"].push(item);
        }
        return data;
    }
}

export interface IBuildRequest {
    description: string;
    approvalStatusFilters?: ApprovalStatus[] | undefined;
    modelStatusFilters?: ModelStatus[] | undefined;
}

export enum BuildState {
    None = "None",
    InProgress = "InProgress",
    Completed = "Completed",
    Cancelling = "Cancelling",
    Postponed = "Postponed",
    NotStarted = "NotStarted",
    All = "All",
}

export class ExternalTableMetaData implements IExternalTableMetaData {
    namespacePrefix?: string | undefined;
    dataQuery?: string | undefined;
    approvalStatus?: string | undefined;
    lastRefreshTimestamp?: Date;
    duplicateIds?: { [key: string]: number; } | undefined;
    labelColumn?: string | undefined;
    iriColumns?: IriColumn[] | undefined;

    constructor(data?: IExternalTableMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namespacePrefix = _data["namespacePrefix"];
            this.dataQuery = _data["dataQuery"];
            this.approvalStatus = _data["approvalStatus"];
            this.lastRefreshTimestamp = _data["lastRefreshTimestamp"] ? new Date(_data["lastRefreshTimestamp"].toString()) : <any>undefined;
            if (_data["duplicateIds"]) {
                this.duplicateIds = {} as any;
                for (let key in _data["duplicateIds"]) {
                    if (_data["duplicateIds"].hasOwnProperty(key))
                        (<any>this.duplicateIds)![key] = _data["duplicateIds"][key];
                }
            }
            this.labelColumn = _data["labelColumn"];
            if (Array.isArray(_data["iriColumns"])) {
                this.iriColumns = [] as any;
                for (let item of _data["iriColumns"])
                    this.iriColumns!.push(IriColumn.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalTableMetaData {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTableMetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namespacePrefix"] = this.namespacePrefix;
        data["dataQuery"] = this.dataQuery;
        data["approvalStatus"] = this.approvalStatus;
        data["lastRefreshTimestamp"] = this.lastRefreshTimestamp ? this.lastRefreshTimestamp.toISOString() : <any>undefined;
        if (this.duplicateIds) {
            data["duplicateIds"] = {};
            for (let key in this.duplicateIds) {
                if (this.duplicateIds.hasOwnProperty(key))
                    (<any>data["duplicateIds"])[key] = this.duplicateIds[key];
            }
        }
        data["labelColumn"] = this.labelColumn;
        if (Array.isArray(this.iriColumns)) {
            data["iriColumns"] = [];
            for (let item of this.iriColumns)
                data["iriColumns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalTableMetaData {
    namespacePrefix?: string | undefined;
    dataQuery?: string | undefined;
    approvalStatus?: string | undefined;
    lastRefreshTimestamp?: Date;
    duplicateIds?: { [key: string]: number; } | undefined;
    labelColumn?: string | undefined;
    iriColumns?: IriColumn[] | undefined;
}

export class IriColumn implements IIriColumn {
    idColumns?: string[] | undefined;
    labelColumn?: string | undefined;

    constructor(data?: IIriColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["idColumns"])) {
                this.idColumns = [] as any;
                for (let item of _data["idColumns"])
                    this.idColumns!.push(item);
            }
            this.labelColumn = _data["labelColumn"];
        }
    }

    static fromJS(data: any): IriColumn {
        data = typeof data === 'object' ? data : {};
        let result = new IriColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idColumns)) {
            data["idColumns"] = [];
            for (let item of this.idColumns)
                data["idColumns"].push(item);
        }
        data["labelColumn"] = this.labelColumn;
        return data;
    }
}

export interface IIriColumn {
    idColumns?: string[] | undefined;
    labelColumn?: string | undefined;
}

export class IriLabelRelation implements IIriLabelRelation {
    workspaceId!: string;
    iri!: string;
    label!: string;

    constructor(data?: IIriLabelRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.iri = _data["iri"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): IriLabelRelation {
        data = typeof data === 'object' ? data : {};
        let result = new IriLabelRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["iri"] = this.iri;
        data["label"] = this.label;
        return data;
    }
}

export interface IIriLabelRelation {
    workspaceId: string;
    iri: string;
    label: string;
}

export class LoadExternalTableRequest implements ILoadExternalTableRequest {
    workspaceId?: string | undefined;
    sourceTableId?: string | undefined;
    namespacePrefix?: string | undefined;
    approvalStatus?: string | undefined;
    dataQuery?: string | undefined;
    changeNote?: string | undefined;
    labelColumn?: string | undefined;
    iriColumns?: IriColumn[] | undefined;

    constructor(data?: ILoadExternalTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.sourceTableId = _data["sourceTableId"];
            this.namespacePrefix = _data["namespacePrefix"];
            this.approvalStatus = _data["approvalStatus"];
            this.dataQuery = _data["dataQuery"];
            this.changeNote = _data["changeNote"];
            this.labelColumn = _data["labelColumn"];
            if (Array.isArray(_data["iriColumns"])) {
                this.iriColumns = [] as any;
                for (let item of _data["iriColumns"])
                    this.iriColumns!.push(IriColumn.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoadExternalTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoadExternalTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["sourceTableId"] = this.sourceTableId;
        data["namespacePrefix"] = this.namespacePrefix;
        data["approvalStatus"] = this.approvalStatus;
        data["dataQuery"] = this.dataQuery;
        data["changeNote"] = this.changeNote;
        data["labelColumn"] = this.labelColumn;
        if (Array.isArray(this.iriColumns)) {
            data["iriColumns"] = [];
            for (let item of this.iriColumns)
                data["iriColumns"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILoadExternalTableRequest {
    workspaceId?: string | undefined;
    sourceTableId?: string | undefined;
    namespacePrefix?: string | undefined;
    approvalStatus?: string | undefined;
    dataQuery?: string | undefined;
    changeNote?: string | undefined;
    labelColumn?: string | undefined;
    iriColumns?: IriColumn[] | undefined;
}

export enum ModelStatus {
    Development = "Development",
    Testing = "Testing",
    Stable = "Stable",
    Deprecate = "Deprecate",
    Withdrawn = "Withdrawn",
}

export class OntologyProject implements IOntologyProject {
    partitionKey!: string;
    name!: string;
    owner!: string;
    timestamp?: Date;
    description?: string | undefined;
    collection?: string | undefined;
    project?: string | undefined;
    repository?: string | undefined;
    accessTokenName?: string | undefined;

    constructor(data?: IOntologyProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partitionKey = _data["partitionKey"];
            this.name = _data["name"];
            this.owner = _data["owner"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.collection = _data["collection"];
            this.project = _data["project"];
            this.repository = _data["repository"];
            this.accessTokenName = _data["accessTokenName"];
        }
    }

    static fromJS(data: any): OntologyProject {
        data = typeof data === 'object' ? data : {};
        let result = new OntologyProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partitionKey"] = this.partitionKey;
        data["name"] = this.name;
        data["owner"] = this.owner;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["collection"] = this.collection;
        data["project"] = this.project;
        data["repository"] = this.repository;
        data["accessTokenName"] = this.accessTokenName;
        return data;
    }
}

export interface IOntologyProject {
    partitionKey: string;
    name: string;
    owner: string;
    timestamp?: Date;
    description?: string | undefined;
    collection?: string | undefined;
    project?: string | undefined;
    repository?: string | undefined;
    accessTokenName?: string | undefined;
}

export class ProjectMetadata implements IProjectMetadata {
    version?: ProjectVersion;

    constructor(data?: IProjectMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? ProjectVersion.fromJS(_data["version"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectMetadata {
    version?: ProjectVersion;
}

export class ProjectVersion implements IProjectVersion {
    major?: number;
    minor?: number;
    build?: number;

    constructor(data?: IProjectVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.build = _data["build"];
        }
    }

    static fromJS(data: any): ProjectVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["build"] = this.build;
        return data;
    }
}

export interface IProjectVersion {
    major?: number;
    minor?: number;
    build?: number;
}

export class Snapshot implements ISnapshot {
    id!: string;
    description!: string;
    owner!: string;
    ownerId!: string;
    createdTimestamp?: Date;

    constructor(data?: ISnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.owner = _data["owner"];
            this.ownerId = _data["ownerId"];
            this.createdTimestamp = _data["createdTimestamp"] ? new Date(_data["createdTimestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Snapshot {
        data = typeof data === 'object' ? data : {};
        let result = new Snapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["owner"] = this.owner;
        data["ownerId"] = this.ownerId;
        data["createdTimestamp"] = this.createdTimestamp ? this.createdTimestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISnapshot {
    id: string;
    description: string;
    owner: string;
    ownerId: string;
    createdTimestamp?: Date;
}

export class SnapshotRequest implements ISnapshotRequest {
    description!: string;

    constructor(data?: ISnapshotRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SnapshotRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SnapshotRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface ISnapshotRequest {
    description: string;
}

export class SourceTable implements ISourceTable {
    name!: string;
    displayName!: string;
    hasMetaData?: boolean;
    isExternal?: boolean;

    constructor(data?: ISourceTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.hasMetaData = _data["hasMetaData"];
            this.isExternal = _data["isExternal"];
        }
    }

    static fromJS(data: any): SourceTable {
        data = typeof data === 'object' ? data : {};
        let result = new SourceTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["hasMetaData"] = this.hasMetaData;
        data["isExternal"] = this.isExternal;
        return data;
    }
}

export interface ISourceTable {
    name: string;
    displayName: string;
    hasMetaData?: boolean;
    isExternal?: boolean;
}

export class SourceTableColumn implements ISourceTableColumn {
    id!: string;
    description?: string | undefined;
    dataType?: SourceTableDataType;
    columnType?: SourceTableColumnType;
    readOnly?: boolean;
    labelFor?: string | undefined;
    autoGenerated?: boolean;

    constructor(data?: ISourceTableColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.dataType = _data["dataType"];
            this.columnType = _data["columnType"];
            this.readOnly = _data["readOnly"];
            this.labelFor = _data["labelFor"];
            this.autoGenerated = _data["autoGenerated"];
        }
    }

    static fromJS(data: any): SourceTableColumn {
        data = typeof data === 'object' ? data : {};
        let result = new SourceTableColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["dataType"] = this.dataType;
        data["columnType"] = this.columnType;
        data["readOnly"] = this.readOnly;
        data["labelFor"] = this.labelFor;
        data["autoGenerated"] = this.autoGenerated;
        return data;
    }
}

export interface ISourceTableColumn {
    id: string;
    description?: string | undefined;
    dataType?: SourceTableDataType;
    columnType?: SourceTableColumnType;
    readOnly?: boolean;
    labelFor?: string | undefined;
    autoGenerated?: boolean;
}

export enum SourceTableColumnType {
    Text = "Text",
    Lookup = "Lookup",
    IRI = "IRI",
    List = "List",
    GovernanceDefinedBy = "GovernanceDefinedBy",
    GovernanceModifiedBy = "GovernanceModifiedBy",
    GovernanceModifiedDate = "GovernanceModifiedDate",
    GovernanceApprovalStatus = "GovernanceApprovalStatus",
    GovernanceModelStatus = "GovernanceModelStatus",
}

export enum SourceTableDataType {
    XsdString = "XsdString",
    XsdDateTime = "XsdDateTime",
    XsdInteger = "XsdInteger",
    XsdInt = "XsdInt",
    XsdDecimal = "XsdDecimal",
    XsdLong = "XsdLong",
    XsdShort = "XsdShort",
    XsdByte = "XsdByte",
    XsdFloat = "XsdFloat",
    XsdDouble = "XsdDouble",
    OwlClass = "OwlClass",
    OwlNamedIndividual = "OwlNamedIndividual",
    OwlObjectProperty = "OwlObjectProperty",
    OwlDataTypeProperty = "OwlDataTypeProperty",
    OwlAnnotationProperty = "OwlAnnotationProperty",
    RdfsResource = "RdfsResource",
    RdfsDatatype = "RdfsDatatype",
    RdfsLiteral = "RdfsLiteral",
    OttrIRI = "OttrIRI",
    OttrBot = "OttrBot",
}

export class SourceTableRow implements ISourceTableRow {
    id!: string;
    values?: { [key: string]: string; } | undefined;

    constructor(data?: ISourceTableRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): SourceTableRow {
        data = typeof data === 'object' ? data : {};
        let result = new SourceTableRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        return data;
    }
}

export interface ISourceTableRow {
    id: string;
    values?: { [key: string]: string; } | undefined;
}

export class SystemSetting implements ISystemSetting {
    azureDevopsTokenExpiry?: Date | undefined;

    constructor(data?: ISystemSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureDevopsTokenExpiry = _data["azureDevopsTokenExpiry"] ? new Date(_data["azureDevopsTokenExpiry"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SystemSetting {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureDevopsTokenExpiry"] = this.azureDevopsTokenExpiry ? this.azureDevopsTokenExpiry.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISystemSetting {
    azureDevopsTokenExpiry?: Date | undefined;
}

export class UpdateIriRequest implements IUpdateIriRequest {
    newId!: string;

    constructor(data?: IUpdateIriRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newId = _data["newId"];
        }
    }

    static fromJS(data: any): UpdateIriRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIriRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newId"] = this.newId;
        return data;
    }
}

export interface IUpdateIriRequest {
    newId: string;
}

export class Workspace implements IWorkspace {
    id!: string;
    title!: string;
    owner!: string;
    ownerId!: string;
    ontologyProject?: string | undefined;
    state?: WorkspaceState;
    numberOfBuilds?: number;
    numberOfSnapshots?: number;
    templateVersion?: string | undefined;
    modifiedTimestamp?: Date;
    projectMetadata?: ProjectMetadata;

    constructor(data?: IWorkspace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.owner = _data["owner"];
            this.ownerId = _data["ownerId"];
            this.ontologyProject = _data["ontologyProject"];
            this.state = _data["state"];
            this.numberOfBuilds = _data["numberOfBuilds"];
            this.numberOfSnapshots = _data["numberOfSnapshots"];
            this.templateVersion = _data["templateVersion"];
            this.modifiedTimestamp = _data["modifiedTimestamp"] ? new Date(_data["modifiedTimestamp"].toString()) : <any>undefined;
            this.projectMetadata = _data["projectMetadata"] ? ProjectMetadata.fromJS(_data["projectMetadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Workspace {
        data = typeof data === 'object' ? data : {};
        let result = new Workspace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["owner"] = this.owner;
        data["ownerId"] = this.ownerId;
        data["ontologyProject"] = this.ontologyProject;
        data["state"] = this.state;
        data["numberOfBuilds"] = this.numberOfBuilds;
        data["numberOfSnapshots"] = this.numberOfSnapshots;
        data["templateVersion"] = this.templateVersion;
        data["modifiedTimestamp"] = this.modifiedTimestamp ? this.modifiedTimestamp.toISOString() : <any>undefined;
        data["projectMetadata"] = this.projectMetadata ? this.projectMetadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkspace {
    id: string;
    title: string;
    owner: string;
    ownerId: string;
    ontologyProject?: string | undefined;
    state?: WorkspaceState;
    numberOfBuilds?: number;
    numberOfSnapshots?: number;
    templateVersion?: string | undefined;
    modifiedTimestamp?: Date;
    projectMetadata?: ProjectMetadata;
}

export class WorkspacePublishRequest implements IWorkspacePublishRequest {
    description!: string;
    projectMetadata?: ProjectMetadata;

    constructor(data?: IWorkspacePublishRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.projectMetadata = _data["projectMetadata"] ? ProjectMetadata.fromJS(_data["projectMetadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkspacePublishRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspacePublishRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["projectMetadata"] = this.projectMetadata ? this.projectMetadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkspacePublishRequest {
    description: string;
    projectMetadata?: ProjectMetadata;
}

export class WorkspaceRequest implements IWorkspaceRequest {
    title!: string;

    constructor(data?: IWorkspaceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): WorkspaceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data;
    }
}

export interface IWorkspaceRequest {
    title: string;
}

export enum WorkspaceState {
    Draft = "Draft",
    Publishing = "Publishing",
    Published = "Published",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}